module.exports = __webpack_public_path__ + "static/media/logo-codepen.5bd8e715.svg";